export const ActionTypes = {
   // Auth Actions
   LOGIN_SUCCESS: 'LOGIN_SUCCESS',
   LOGIN_ERROR: 'LOGIN_ERROR',
   LOGOUT: 'LOGOUT',
   SIGNUP_SUCCESS: 'SIGNUP_SUCCESS',
   SIGNUP_ERROR: 'SIGNUP_ERROR',
   AUTH_STATE_CHANGED: 'AUTH_STATE_CHANGED',
   COUCH_STATUS_CHANGED: 'COUCH_STATUS_CHANGED',
   SYNC_BLOCKED: 'SYNC_BLOCKED',
   CREDENTIALS_REFRESH_NEEDED: 'CREDENTIALS_REFRESH_NEEDED',

   // Workspace state machine actions
   WORKSPACE_AUTHENTICATED: 'WORKSPACE_AUTHENTICATED',
   WORKSPACE_PROVISIONING: 'WORKSPACE_PROVISIONING',
   WORKSPACE_READY: 'WORKSPACE_READY',
   WORKSPACE_DEGRADED: 'WORKSPACE_DEGRADED',

   // Sync health tracking
   SYNC_HEALTH_UPDATE: 'SYNC_HEALTH_UPDATE',

   // Project Actions
   CREATE_PROJECT: 'CREATE_PROJECT',
   UPDATE_PROJECT: 'UPDATE_PROJECT',
   DELETE_PROJECT: 'DELETE_PROJECT',
   SELECT_PROJECT: 'SELECT_PROJECT',
   LOAD_PROJECTS: 'LOAD_PROJECTS',
   PROJECTS_LOADED: 'PROJECTS_LOADED',

   // Scene Actions
   CREATE_SCENE: 'CREATE_SCENE',
   UPDATE_SCENE: 'UPDATE_SCENE',
   DELETE_SCENE: 'DELETE_SCENE',
   SELECT_SCENE: 'SELECT_SCENE',
   LOAD_SCENES: 'LOAD_SCENES',
   SCENES_LOADED: 'SCENES_LOADED',

   // Location Actions
   CREATE_LOCATION: 'CREATE_LOCATION',
   UPDATE_LOCATION: 'UPDATE_LOCATION',
   DELETE_LOCATION: 'DELETE_LOCATION',
   SELECT_LOCATION: 'SELECT_LOCATION',
   LOAD_LOCATIONS: 'LOAD_LOCATIONS',
   LOCATIONS_LOADED: 'LOCATIONS_LOADED',

   // Character Actions
   CREATE_CHARACTER: 'CREATE_CHARACTER',
   UPDATE_CHARACTER: 'UPDATE_CHARACTER',
   DELETE_CHARACTER: 'DELETE_CHARACTER',
   SELECT_CHARACTER: 'SELECT_CHARACTER',
   LOAD_CHARACTERS: 'LOAD_CHARACTERS',
   CHARACTERS_LOADED: 'CHARACTERS_LOADED',

   // Plot Actions
   CREATE_PLOT: 'CREATE_PLOT',
   UPDATE_PLOT: 'UPDATE_PLOT',
   DELETE_PLOT: 'DELETE_PLOT',
   SELECT_PLOT: 'SELECT_PLOT',
   LOAD_PLOTS: 'LOAD_PLOTS',
   PLOTS_LOADED: 'PLOTS_LOADED',

   // UI Actions
   SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
   TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
   SHOW_MODAL: 'SHOW_MODAL',
   HIDE_MODAL: 'HIDE_MODAL',
   SET_LOADING: 'SET_LOADING',
   SET_ERROR: 'SET_ERROR',
   CLEAR_ERROR: 'CLEAR_ERROR',
};
